import { useState } from 'react';
import BacktestControlPanel from '../components/BacktestControlPanel';
import BacktestTable from '../components/BacktestTable';

// Interactive backtest for the cheap-bot ignition trigger (backend:
// handlers/cheap_backtest_run.go + cmd/cheapbacktest, both built on
// backend/backtest). Each variant gets its own control panel (date-range
// picker, on-demand data cache via "Load Data", live-editable strategy
// params, stoppable "Start"/"Stop" run) directly above its results table.
// Split out from the live-trading Bot page 2026-07-11. Admin-only.
export default function BotTest() {
  const [spyRefresh, setSpyRefresh] = useState(0);
  const [spxRefresh, setSpxRefresh] = useState(0);

  return (
    <div>
      <BacktestControlPanel variant="spy" onResultsUpdated={() => setSpyRefresh((n) => n + 1)} />
      <BacktestTable
        variant="spy"
        title="Backtest (SPY)"
        subtitle="Pick a test period above, Load Data to cache it (only fetched from Alpaca once), then Start to run the ignition trigger against it with the parameters shown. Bars carry no bid/ask, so entries are simulated at last-trade (slightly optimistic vs paying the ask)."
        refreshSignal={spyRefresh}
      />
      <BacktestControlPanel variant="spx" onResultsUpdated={() => setSpxRefresh((n) => n + 1)} />
      <BacktestTable
        variant="spx"
        title="Backtest (SPX)"
        subtitle="Same simulation at SPX scale, own independent test period/params/data cache."
        refreshSignal={spxRefresh}
      />
    </div>
  );
}
